import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { enable_notifications } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformMediaAutomaticConversion() {
    const { t } = useTranslation('settings');

    const options = enable_notifications(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key="media_automatic_conversion"
            control={control}
            name="media_automatic_conversion"
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        tooltipContent={t('platform_page.media_automatic_conversion_tooltip')}
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.media_automatic_conversion')}
                        error={errors.media_automatic_conversion?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
